import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Course } from 'src/app/models/course';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CoursesService {
  private readonly serviceName = 'courses';
  private readonly headers = {
    headers: new HttpHeaders({
      "Authorization": `Bearer ${environment.apiKeyInternal}`
    })
  };

  constructor(private http: HttpClient) {}

  public get(): Observable<Course[]> {
    return this.http.get<Course[]>(
      `${environment.apiUrl}${this.serviceName}/get.php`,
      this.headers
    );
  }

  public set(course: Course): Observable<void> {
    const payload = `cid=${course.cid}&name=${course.name}&diffname=${course.diffname}
                     &description=${course.description}&level=${course.level}
                     &link=${course.link}&color=${course.color}&age_begin=${course.age_begin}&age_end=${course.age_end}`;
    
    return this.http.post<void>(
      `${environment.apiUrl}${this.serviceName}/set.php`,
      payload,
      this.headers
    );
  }

  public del(course: Course): Observable<void> {
    const payload = `cid=${course.cid}`;

    return this.http.post<void>(
      `${environment.apiUrl}${this.serviceName}/del.php`,
      payload,
      this.headers
    );
  }  
}
